<template>
  <navbar>
    <button class="navbar-toggler mobile-sidebar-toggler d-lg-none" type="button" @click="mobileSidebarToggle">&#9776;</button>
    <router-link v-if="IsThemeSDS" :to="{ name: 'StartPage' }" class="navbar-brand">
      <small>Backoffice</small>
    </router-link>
    <router-link v-else-if="IsThemeCOTEXO" :to="{ name: 'StartPage' }" class="navbar-brand-cotexo">
      <small><img src="/static/clients/cotexo/logo.png" alt="Logo-Cotexo" width="145px"/></small>
    </router-link>
    <router-link v-else-if="IsThemeCONSTAR" :to="{ name: 'StartPage' }" class="navbar-brand-constar">
      <small style="font-size: 26px;">Backoffice</small>
    </router-link>
    <router-link v-else :to="{ name: 'StartPage' }" class="navbar-brand-acelerauto">
      <small><img src="/static/clients/acelerauto/Logo-Acelerauto-Negativo.png" alt="Logo-Acelerauto" width="70px"/></small>
    </router-link>
    <ul class="nav navbar-nav d-md-down-none">
      <li class="nav-item">
        <a class="nav-link navbar-toggler sidebar-toggler" href="#" @click="sidebarMinimize">&#9776;</a>
      </li>
      <li class="nav-item px-3">
        <a class="nav-link" href="javascript:void(0)" @click="toggleFullScreen"><i class="fa fa-arrows-alt" v-b-tooltip.hover :title="$lang.Common.Buttons.Fullscreen"></i></a>
      </li>
    </ul>
    <ul class="nav navbar-nav ml-auto">
      <li class="divider-vertical d-md-down-none"></li>
      <li class="nav-item d-sm-down-none">
        <a class="nav-link" href="#"><i class="fa fa-flag"></i></a>
      </li>
      <li class="nav-item d-sm-down-none">
        <a class="nav-link" href="javascript:void(0);"><i class="icon-bell"></i><span class="badge badge-pill badge-default">0</span></a>
      </li>
      <li class="divider-vertical d-md-down-none"></li>
      <li class="nav-item d-sm-down-none">
        <a class="nav-link" href="javascript:void(0);" @click="asideToggle"><i class="fa fa-comments-o"></i></a>
      </li>
      <li class="nav-item d-md-down-none">
        <a class="nav-link" href="javascript:void(0);"><i class="fa fa-envelope-o"></i></a>
      </li>
      <li class="divider-vertical d-md-down-none"></li>

      <b-dropdown variant="link" no-caret class="pl-2">
        <template slot="button-content">
          <b-avatar class="mr-1"></b-avatar>
          <span class="d-md-down-none" style="min-width: 190px; color: #fff;">{{AccountName}}</span>
          <i class="fa fa-caret-down" style="color:#fff;"></i>
        </template>
        <b-dropdown-item :to="{ name: 'MinhaConta' }"><i class="fa fa-user"></i>Minha Conta</b-dropdown-item>
        <b-dropdown-item href="javascript:void(0)" @click="onSignOut"><i class="fa fa-lock"></i> Sair</b-dropdown-item>
      </b-dropdown>

      <li class="pr5 d-md-down-none">&nbsp;</li>
      <!--
      <li class="nav-item d-md-down-none">
        <a class="nav-link navbar-toggler aside-menu-toggler" href="#" @click="asideToggle">&#9776;</a>
      </li>
      -->
    </ul>
  </navbar>
</template>
<script>

import { JWTService } from '@/shared/services/jwt'
import router from '@/router'
import navbar from './Navbar'

export default {
  name: 'AppHeader',
  data () {
    return {
      display: '',
      imgAvatar: process.env.BaseURL + 'static/img/avatars/02.png',
      AccountName: decodeURIComponent(escape(JWTService.GetTokenPayload().Name)), // decode_utf8 | http://ecmanaut.blogspot.com/2006/07/encoding-decoding-utf8-in-javascript.html
      AccountEmail: JWTService.GetTokenPayload().Email,
      theme: process.env.Theme
    }
  },
  computed: {
    IsThemeSDS: function () {
      var result = false
      if (this.theme === 'SDS') {
        result = true
      }
      return result
    },
    IsThemeCOTEXO: function () {
      var result = false
      if (this.theme === 'COTEXO') {
        result = true
      }
      return result
    },
    IsThemeCONSTAR: function () {
      var result = false
      if (this.theme === 'CONSTAR') {
        result = true
      }
      return result
    }
  },
  components: {
    navbar
  },
  methods: {
    onSignOut () {
      JWTService.DestroyToken()
      router.replace('/login')
    },

    click () {
      // do nothing
    },
    sidebarToggle (e) {
      e.preventDefault()
      document.body.classList.toggle('sidebar-hidden')
    },
    sidebarMinimize (e) {
      e.preventDefault()
      document.body.classList.toggle('sidebar-minimized')
    },
    mobileSidebarToggle (e) {
      e.preventDefault()
      document.body.classList.toggle('sidebar-mobile-show')
      // this.display = 'none'
    },
    asideToggle (e) {
      e.preventDefault()
      document.body.classList.toggle('aside-menu-hidden')
    },
    toggleFullScreen () {
      if ((document.fullScreenElement && document.fullScreenElement !== null) || (!document.mozFullScreen && !document.webkitIsFullScreen)) {
        // topMenuData.showSmall = true
        if (document.documentElement.requestFullScreen) {
          document.documentElement.requestFullScreen()
        } else if (document.documentElement.mozRequestFullScreen) {
          document.documentElement.mozRequestFullScreen()
        } else if (document.documentElement.webkitRequestFullScreen) {
          document.documentElement.webkitRequestFullScreen(Element.ALLOW_KEYBOARD_INPUT)
        }
      } else {
        //  this.topMenuData.showSmall = false
        if (document.cancelFullScreen) {
          document.cancelFullScreen()
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen()
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen()
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/containers/layout/Header.vue